import { If } from '@payments-checkout/shared/components';
import { usePaymentMethod } from '@payments-checkout/shared/providers';
import {
  Text
} from '@stone-payments/jade';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { DigitalWalletSelectionOption } from '../../app/components/digitalWallets/digitalWalletSelection.component';
import { digitalWallets } from '../../app/types/digitalWallets.types';
import { usePageSharedData } from '../../hooks/usePageSharedData';
import { ClickToPayLogoIllustration } from './clickToPayLogo.illustration';

type ClickToPayProps = {
  setIsDigitalWalletsSelected: (digitalWallet: digitalWallets) => void;
  active?: boolean;
};

export const ClickToPay = ({
  setIsDigitalWalletsSelected,
  active = false,
}: ClickToPayProps) => {
  const { paymentLinkIdData } = usePageSharedData();
  const { isCustomerFormLoading } = usePaymentMethod();
  const { formatMessage } = useIntl();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.matchMedia('(max-width: 768px)').matches);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const acceptedMethods =
    paymentLinkIdData?.data?.payment_settings.accepted_payment_methods ?? [];
  const hasCredit = acceptedMethods.includes('credit_card');
  const hasDebit = acceptedMethods.includes('debit_card');
  const hasApplePay = !!paymentLinkIdData?.data?.apple_payment_details;

  const getLabelId = () => {
    if (hasCredit && hasDebit) return 'clickToPay.label.creditAndDebit';
    if (hasCredit) return 'clickToPay.label.credit';
    return 'clickToPay.label.debit';
  };

  const label = formatMessage({ id: getLabelId() });

  return (
    <If
      condition={
        !!paymentLinkIdData?.data?.payment_settings.click_to_pay_enabled
      }
    >
      <DigitalWalletSelectionOption
        onClick={() => {
          setIsDigitalWalletsSelected('clickToPay');
        }}
        active={active}
        name="clickToPay"
        disabled={isCustomerFormLoading}
      >
        <div className="flex flex-col items-center gap-1">
          <ClickToPayLogoIllustration />
          <Text
            variant="text-small"
            color="medium"
            style={isMobile && hasApplePay ? { fontSize: '8px' } : undefined}
          >
            {label}
          </Text>
        </div>
      </DigitalWalletSelectionOption>
    </If>
  );
};
